// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_thorns: PokeData = {
  "id": 995,
  "name": "iron-thorns",
  "height": 16,
  "weight": 3030,
  "base_experience": 285,
  "types": [
    PokeType.ROCK,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "pin-missile",
    "bite",
    "rock-throw",
    "earthquake",
    "screech",
    "rock-slide",
    "sandstorm",
    "charge",
    "rock-tomb",
    "iron-defense",
    "giga-impact",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stone-edge",
    "stealth-rock",
    "wild-charge"
  ],
  "moves": [
    "pin-missile",
    "bite",
    "rock-throw",
    "earthquake",
    "rock-slide",
    "sandstorm",
    "rock-tomb",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "stealth-rock",
    "wild-charge",
    "quick-tempo"
  ],
  "evolution_chain": {
    "id": 526,
    "item": null,
    "species": [
      {
        "name": "iron-thorns",
        "order": 991,
        "types": [
          PokeType.ROCK,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 95,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
